import { css } from '@emotion/css';
import {
  appColors,
  breakpoints,
  fontFamily,
  fontWeight,
} from '../styles/variables.style';
import rocket from '../assets/images/img-3827.jpeg';
import bear from '../assets/images/img-3928.jpeg';
import glitterbg from '../assets/images/glitter.gif';

export const editBtn = css`
  background: transparent;
  width: 25px;
  padding: 0;
  float: right;
  margin-bottom: 8px;
  &:hover {
    background: transparent;
  }
  img {
    width: 30px;
  }
`;


export const container = css`
  background: ${appColors.white};
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin: 20px auto;
  max-width: none;
  min-height: 450px;
  padding: 10px;

  @media (min-width: ${breakpoints.lg.up}) {
    margin: 0px 80px;
    padding: 20px;
  }

  &.no-shadow {
    box-shadow: none;
  }

  &.inner {
    background: url(${bear}) no-repeat top left,
      url(${rocket}) no-repeat 100% 80%;
  }
`;

export const countdown = css`
  font-size: 17px;
  color: ${appColors.gray800};
`;

export const progress = css`
  display: flex;
  align-items: center;

  @media (min-width: ${breakpoints.xl.up}) {
    position: absolute;
  }

  .s-title {
    font-size: 15px;
    font-weight: ${fontWeight.bold};
    text-transform: uppercase;
    margin: 0 0 0 20px;
  }
`;

export const buttonGroup = css`
  display: flex;
  justify-content: flex-end;
  align-items: center; /* Ensures buttons are vertically aligned */
  // background: ${appColors.orange};
  border-radius: 10px;
  padding: 15px 20px; /* Adjusted padding for better spacing */

  @media (min-width: ${breakpoints.lg.up}) {
    padding: 15px 30px; /* Increased padding for larger screens */
  }

  button {
    background: ${appColors.orange}; /* Added a background for better contrast */
    color: ${appColors.white}; /* Matches the theme */
    text-transform: uppercase;
    font-size: 16px; /* Slightly reduced font size for better balance */
    font-weight: ${fontWeight.bold};
    padding: 10px 15px; /* Adjusted padding for better button size */
    border: 2px solid ${appColors.orange}; /* Added a border for definition */
    border-radius: 5px; /* Rounded corners for a modern look */
    cursor: pointer; /* Ensures the pointer changes on hover */
    transition: all 0.3s ease; /* Smooth transition for hover effects */

    &:hover {
      background: ${appColors.orange}; /* Invert colors on hover */
      color: ${appColors.white};
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Add a subtle shadow */
    }

    &:not(:last-child) {
      margin-right: 10px; /* Add spacing between buttons */
    }
  }
`;

export const buttonGroup_review = css`             
  display: flex;
  justify-content: flex-end; 
  align-items: center;       
  background: ${appColors.orange};
  margin-top:2px;
  border-radius: 10px;
  padding: 10px;
  // border:2px solid green;
  @media (min-width: ${breakpoints.lg.up}) {
    padding: 20px 20px 20px 20px;
  }

  button {
    background: none;
    color: ${appColors.white};
    text-transform: uppercase;
    font-size: 18px;
    font-weight: ${fontWeight.bold};
    padding: 0 10px;
    // border:2px solid red;
    &:hover {
      background: none;
      color: ${appColors.gray200};
    }
  }
`;


export const img = css`
  display: block;
  max-width: 100%;
  margin: 0 auto;
`;

export const title = css`
  color: ${appColors.orange};
  font-size: 30px;
  margin: 0 0 20px;
  font-family: ${fontFamily.fredoka};

  @media (min-width: ${breakpoints.lg.up}) {
    font-size: 40px;
    margin: 0 0 20px;
  }

  &.color-black {
    color: ${appColors.gray800};
  }
`;

export const attempt = css`
  font-size: 24px;
  margin-top: 70px;
  margin-bottom: 20px;
  text-align: center;
  font-weight: ${fontWeight.semiBold};

  span {
    color: ${appColors.orange};
  }
`;

export const btnGroup = css`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
  position: relative;
  z-index: 10000;

  a {
    display: inline-block;
    margin: 0 10px;
    text-decoration: none;
  }

  button {
    min-width: 150px;
    padding: 12px 25px;
    font-size: 16px;
    font-weight: ${fontWeight.bold};
    color: ${appColors.white};
    background: ${appColors.orange};
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.3s ease;
    text-transform: uppercase;
    position: relative;
    z-index: 10001;
    
    &:hover {
      background: ${appColors.orangeDark};
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }
  }
`;

export const summary = css`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  border: 2px solid ${appColors.orange};
  padding: 20px 0;
  border-radius: 10px;
  margin: 0 0 20px;

  @media (min-width: ${breakpoints.lg.up}) {
    padding: 20px 0;
  }

  .item {
    flex: 0 0 50%;
    padding: 20px 10px;
    text-align: center;

    &:nth-child(odd) {
      border-right: 1px solid ${appColors.gray200};
    }

    @media (min-width: ${breakpoints.lg.up}) {
      flex: 0 0 25%;
      padding: 0 60px;

      &:not(:last-child) {
        border-right: 1px solid ${appColors.gray200};
      }
    }

    .s-title {
      margin: 0 0 10px;
    }

    .sub-title {
      font-size: 18px;
      margin: 0;
    }
  }
`;

export const table = css`
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  min-width: 750px;

  th,
  td {
    text-align: left;

    &:not(:last-child) {
      border-right: 1px solid ${appColors.gray200};
    }

    &:first-child {
      border-radius: 10px 0 0 10px;
    }

    &:last-child {
      border-radius: 0 10px 10px 0;
    }
  }

  th {
    padding: 10px;
    background: ${appColors.orange};
    color: ${appColors.white};
    font-size: 18px;

    @media (min-width: ${breakpoints.lg.up}) {
      padding: 20px;
    }
  }

  td {
    padding: 10px;
    border-bottom: 1px solid ${appColors.gray200};

    @media (min-width: ${breakpoints.lg.up}) {
      padding: 10px 20px;
    }
  }

  tr:last-child td {
    border-bottom: none;
  }
`;

export const photoTableImg = css`
  display: block;
  width: 100px;
  height: 100px;
`;

export const glitter = css`
  position: relative;
  z-index: 1;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 200px;
    max-width: 900px;
    margin: 0 auto;
    background: url(${glitterbg}) repeat-x center;
    background-size: 120px;
    z-index: -1;

    @media (min-width: ${breakpoints.md.up}) {
      background-size: 170px;
    }
  }
`;

export const line = css`
  font-size: 33px;
  span {
    color: ${appColors.orange};
  }
`;

export const overflowXHidden = css`
  canvas {
    width: 100% !important;
  }
`;
